module.exports = __webpack_public_path__ + "img/xmark-octagon_fill.92cbfd15.svg";